import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';

export default function CertificateGenerator({
  studentName = "Nombre del Estudiante",
  courseTitle = "Curso de Blockchain"
}) {
  const certificateRef = useRef(null);
  const [isGenerating, setIsGenerating] = useState(false);

  const generateImage = async () => {
    setIsGenerating(true);
    const canvas = await html2canvas(certificateRef.current);
    const imgData = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.download = "certificado.png";
    link.href = imgData;
    link.click();
    setIsGenerating(false);
  };

  return (
    <div style={{ textAlign: "center", fontFamily: "Georgia, serif", marginTop: "40px" }}>
      <div
        ref={certificateRef}
        style={{
          position: "relative",
          width: "1000px",
          height: "700px",
          margin: "auto",
          backgroundColor: "#fff",
          borderRadius: "20px",
          border: "6px solid #001f3f",
          overflow: "hidden",
          boxShadow: "0 0 15px rgba(0,0,0,0.2)"
        }}
      >
        {/* Ondas en SVG */}
        <svg
          viewBox="0 0 1000 400"
          preserveAspectRatio="none"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '280px',
            zIndex: 1
          }}
        >
          <defs>
            {/* Gradiente metálico azul oscuro */}
            <linearGradient id="metalBlue" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#0f2027" />
              <stop offset="25%" stopColor="#203a43" />
              <stop offset="50%" stopColor="#2c5364" />
              <stop offset="75%" stopColor="#203a43" />
              <stop offset="100%" stopColor="#0f2027" />
            </linearGradient>

            {/* Azul claro satinado para la franja delgada */}
            <linearGradient id="lightBlue" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#5dade2" />
              <stop offset="50%" stopColor="#a9cce3" />
              <stop offset="100%" stopColor="#5dade2" />
            </linearGradient>

            <linearGradient id="gold" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#f6e27a" />
              <stop offset="20%" stopColor="#f7d358" />
              <stop offset="40%" stopColor="#f4c542" />
              <stop offset="60%" stopColor="#e6b800" />
              <stop offset="80%" stopColor="#f4c542" />
              <stop offset="100%" stopColor="#f6e27a" />
            </linearGradient>

          </defs>



          {/* Onda principal */}
          <path
            d="M0,240 C250,400 750,80 1000,240 L1000,0 L0,0 Z"
            fill="url(#metalBlue)"
          />

          {/* Franja delgada decorativa */}
          {/* Franja azul clara siguiendo la misma forma */}
          <path
            d="M0,310 C250,400 750,80 1000,240 L1000,250 C750,90 250,410 0,200 Z"
            fill="url(#gold)"
          />
        </svg>

        {/* Texto superior */}
        <div style={{ position: "absolute", top: 40, left: 40, zIndex: 2, color: "white" }}>
          <h2 style={{ margin: 0, fontSize: "28px", fontWeight: "bold", letterSpacing: 1 }}>COLLEGE NAME</h2>
          <p style={{ fontSize: "13px", maxWidth: "260px" }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
        </div>

        {/* Contenido principal */}
        <div
          style={{
            position: "relative",
            zIndex: 3,
            paddingTop: "280px",
            padding: "40px",
            boxSizing: "border-box",
            height: "100%"
          }}
        >
          <h1 style={{ fontSize: "36px", marginBottom: "5px", color: "#002855" }}>CERTIFICATE</h1>
          <h2 style={{ fontSize: "18px", marginBottom: "30px", color: "#002855" }}>OF GRADUATION</h2>

          <h3
            style={{
              fontSize: "32px",
              fontFamily: "'Great Vibes', cursive",
              color: "#c59f28",
              margin: "20px 0"
            }}
          >
            {studentName}
          </h3>

          <p
            style={{
              fontSize: "18px",
              textAlign: "center",
              padding: "0 40px",
              color: "#444",
              lineHeight: 1.8
            }}
          >
            Por medio de la presente, se certifica que <strong>{studentName}</strong> ha completado satisfactoriamente el curso <strong>{courseTitle}</strong>, impartido en colaboración entre <strong>Coach Blockchain</strong>, <strong>Inteligencia Educa</strong> y la <strong>UVEG</strong>, con una duración total de <strong>114 horas</strong>.
          </p>

          {/* Firma y sello */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "60px" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #000", width: "200px", margin: "0 auto 5px" }}></div>
              <div style={{ fontWeight: "bold" }}>Coordinación Académica</div>
              <div>Coach Blockchain</div>
            </div>

            <div>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Red_wax_seal.svg/768px-Red_wax_seal.svg.png"
                alt="Sello"
                style={{ height: "60px", opacity: 0.9 }}
              />
            </div>
          </div>

          {/* Ubicación y firma digital */}
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              left: "40px",
              fontSize: "14px",
              color: "#333"
            }}
          >
            Guanajuato, México
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              right: "40px",
              fontSize: "14px",
              color: "#333"
            }}
          >
            Firma Digital
          </div>
        </div>
      </div>

      {/* Botón de descarga */}
      <button
        onClick={generateImage}
        disabled={isGenerating}
        style={{
          marginTop: "30px",
          padding: "12px 24px",
          fontSize: "16px",
          backgroundColor: "#002855",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer"
        }}
      >
        {isGenerating ? "Generando..." : "Descargar como PNG"}
      </button>
    </div>
  );
}
